import { createFileRoute } from "@tanstack/react-router";
import Page, { seo } from "@/pages/services/ongoing-support";
import { buildServiceHead } from "@/lib/service-seo";

export const Route = createFileRoute("/services/ongoing-support")({
  head: () => buildServiceHead(seo),
  component: Page,
});
